/**
 * Pure UTC clock formatting utility.
 * Extracted so it can be unit-tested without importing React or API clients.
 */

/**
 * Format a Date as "HH:MM:SS UTC".
 * Uses UTC hours/minutes/seconds with zero-padding.
 */
export function formatUtcClock(d: Date): string {
  const hh = String(d.getUTCHours()).padStart(2, '0')
  const mm = String(d.getUTCMinutes()).padStart(2, '0')
  const ss = String(d.getUTCSeconds()).padStart(2, '0')
  return `${hh}:${mm}:${ss} UTC`
}
